import { APIScope, APIScopePermission, LimitToLocationScopes, Log, MemberPermission, RoleInterface, RoleInterfaceMap } from "@swivl-mono/types";

import { CreateLogger } from "../Loggers/SwivlLoggers";

const log = CreateLogger(Log.AUTH, "check-permissions");

export function Internal_CheckPermissions(
  parentRoles: RoleInterfaceMap | undefined,
  roles: RoleInterfaceMap,
  memberPermissions: MemberPermission[],
  scope: APIScope,
  orgId: number,
  groupIdParam?: number,
  locationId?: number,
): boolean {
  log("Internal_CheckPermissions :", memberPermissions, scope, orgId, groupIdParam, locationId);
  // Helper function to check permissions recursively if the permission is inherited

  // do any members have super admin?

  function checkPermissionInRole(role: RoleInterface, scope: APIScope): APIScopePermission {
    if (role && role.actions && role.actions[scope]) {
      if (role.actions[scope] === APIScopePermission.ALLOWED) {
        return APIScopePermission.ALLOWED;
      }
      if (role.actions[scope] === APIScopePermission.FORBIDDEN) {
        return APIScopePermission.FORBIDDEN;
      }
    }
    if (
      // role.actions[scope] === APIScopePermission.INHERITED &&

      role.parentSlug &&
      parentRoles
    ) {
      const parentRole = parentRoles[role.parentSlug];
      if (parentRole) {
        return checkPermissionInRole(parentRole, scope);
      }
    }
    return APIScopePermission.FORBIDDEN; // Default to forbidden if not explicitly allowed or inherited
  }

  // Iterate over each member permission
  for (const memberPermission of memberPermissions) {
    log("memberPermission :locations", memberPermission.locations);
    // if (memberPermission.orgId !== orgId) continue; // Skip if orgId does not match

    const role = roles?.[memberPermission.roleSlug] || parentRoles?.[memberPermission.roleSlug];

    log("checking", scope, locationId, groupIdParam, role);
    if (!role) continue; // Skip if role is not found

    if (!LimitToLocationScopes.includes(scope)) {
      if (checkPermissionInRole(role, scope) === APIScopePermission.ALLOWED) {
        log("mk0");

        return true;
      }
    }
    // Check permissions for the organization level
    log("checking org id", memberPermission.locations.orgId, orgId);
    if (memberPermission.locations.orgId === orgId) {
      if (checkPermissionInRole(role, scope) === APIScopePermission.ALLOWED) {
        log("mk1");
        return true;
      }
    }

    // Check permissions for specific group
    if (groupIdParam && memberPermission.locations.groupIds?.includes(groupIdParam)) {
      if (checkPermissionInRole(role, scope) === APIScopePermission.ALLOWED) {
        log("mk2");

        return true;
      }
    }
    // Check permissions for specific location
    if (locationId && memberPermission.locations.locationIds?.includes(locationId)) {
      if (checkPermissionInRole(role, scope) === APIScopePermission.ALLOWED) {
        log("mk3");

        return true;
      }
    }
  }
  log("mk4");

  return false;
}

// interface MemberPermissionWithRole extends MemberPermission {
//     role: RoleInterface
// }

// //NOTE: this function should be wrapped in a helper function.

// export function Internal_CheckPermissions2(
//     parentRoles: RoleInterfaceMap | undefined,
//     roles:RoleInterfaceMap,
//     memberPermissions:MemberPermission[],
//     scope:APIScope,
//     orgId: number,
//     groupIdParam?: number,
//     locationId?: number,
// ):boolean {

//     const grants = (AnyScopeAPIScope.includes(scope)) ? memberPermissions : AuthGetScopedPermissions(memberPermissions, orgId, groupIdParam, locationId);
//     if (!grants?.length) {
//         log('No grants found for this action', memberPermissions, scope)
//         return false;
//     }
//     log('grants :', grants);

//     let grantsWithRoles: MemberPermissionWithRole[] = []
//     log('grantsWithRoles 1:', grantsWithRoles);

//     for (let i = 0; i < grants.length; i++) {
//         const grant = grants[i];
//         if (roles && roles[grant.roleSlug]) {
//             grantsWithRoles.push({
//                 ...grant,
//                 role: roles[grant.roleSlug]
//             })

//         } else if (parentRoles && parentRoles[grant.roleSlug]) {
//             grantsWithRoles.push({
//                 ...grant,
//                 role: parentRoles[grant.roleSlug]
//             })
//         } else {
//
//             return false;
//         }
//     }

//     log('grantsWithRoles 2:', grantsWithRoles);
//     log("Roles : ", roles);

//     const filteredRoles = Object.values(roles).filter((role) => {
//         return grants.some((grant) => {
//             return role.slug === grant.roleSlug;
//         });
//     })

//     log("Roles : ", roles);
//     log('filteredRoles :', filteredRoles);

//     if (!filteredRoles.length) {
//
//         return false;
//     }

//    // Pass in parent roles here too.
//     const allowed = AllowedScopesForRoles(parentRoles, filteredRoles).includes(scope);
//     log('allowed :', allowed);

//     return true;
// }
